// src/auth/authConfig.js
export const msalConfig = {
    auth: {
        clientId: "cc3cb809-9a8d-43ae-ad43-ea58ac4ee4dc",  // Your Application (Client) ID from Azure
        authority: "https://login.microsoftonline.com/consumers", // Multi-tenant authentication
        redirectUri: window.location.origin, // Automatically switches between local & production
    }
};
